import { render, staticRenderFns } from "./PolicyInfo.vue?vue&type=template&id=158d9cd0"
import script from "./PolicyInfo.vue?vue&type=script&lang=ts"
export * from "./PolicyInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports